import React from 'react';
import { useTranslation } from 'react-i18next';
import { Images } from "../Common/Images";

const RegisterSuccess = () => {

    const { t } = useTranslation("common");

    return (
        <div className="main-area">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12 d-flex align-items-center justify-content-center vh-adjust">
                        <div className="green-box green-lightopacity">
                            <h1 className="fade-in-animation" style={{ display: 'block' }}>{t("congratulations")}</h1>
                            <img src={Images.ThumbsUp} alt="" className="check-circle fade-in-animation" style={{ display: 'block' }} />
                            <div className="success-text fade-in-animation" style={{ display: 'block' }}>
                                <h3>{t("react_account_created_successfully")}</h3>
                                <p className="verify-now">{t("link_confirmation_sent_on_provided_email")}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RegisterSuccess;